var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("PlaceOfWorkEdit", {
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.placeOfWork,
              callback: function($$v) {
                _vm.placeOfWork = $$v
              },
              expression: "placeOfWork"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("h2", [_vm._v("Bietet Ihr Homeoffice / Remote Work?")]),
          _vm._v(" "),
          _c("HomeOfficeEdit", {
            attrs: { "first-label": false, simple: "" },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.homeOffice,
              callback: function($$v) {
                _vm.homeOffice = $$v
              },
              expression: "homeOffice"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "font-weight-extra-bold" }, [
        _vm._v(
          "\n\t\t\t\t\tMehrfachauswahl möglich, wenn unterschiedliche Arbeitsorte möglich sind.\n\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\t\t\tWenn großteils Remote/Homeoffice vorgesehen ist, gib bitte Euren Hauptsitz für diesen Job ein.\n\t\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }